<template>
  <div v-if="!loaded || mainError" class="mx-auto my-auto">
    <div v-if="!mainError">{{ $t("Loading schedule") }}</div>
    <div v-else>{{ mainError }}</div>
  </div>
  <v-container v-else ref="container" :style="loading ? { opacity: 0.5 } : {}">
    <v-dialog v-if="questId" ref="dialog" v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>
          <h2 style="word-break: normal; width: 100%" class="text-center">
            {{ $t("Booking") }}
          </h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p class="text-center pb-1 font-weight-bold" style="font-size: 1rem">
                {{ $t("Date") }}:
                <v-icon>mdi-calendar-month</v-icon>
                {{ bookInfo.date }} {{ bookInfo.time }}
                <br />
                {{ $t("Price") }}:
                <span v-if="discounts.length"><small><span class="old-price">{{ fullPrice }}</span></small> {{ bookPrice
                }}</span>
                <span v-else>{{ bookPrice }}</span>
                {{ questsMap[questId].currency }}
                <template v-if="discounts.length">
                  <br><b>{{ $t("Discount") }}: <template v-for="discount in discounts">{{ discount }} </template></b>
                </template>

              </p>
            </v-col>
            <v-col :cols="(bookInfo.availableModes.length % 2 === 1) &
              (idx === bookInfo.availableModes.length - 1)
              ? 12
              : 6
              " class="py-0 my-0" v-for="(group, idx) in bookInfo.availableModes" :key="idx">
              <v-select dense :items="group.modes" :label="group.name || $t('Mode')" item-text="text" item-value="num"
                @change="modeChanged" v-model="bookInfo.modes[idx]"></v-select>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-text-field dense :label="$t('Name')" v-model="bookInfo.name" :error-messages="errors.name"
                prepend-icon="mdi-account"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field v-show="selected_contact == 0" dense :label="$t('Phone')" v-model="bookInfo.phone"
                :error-messages="errors.phone" prepend-icon="mdi-phone"></v-text-field>
            </v-col>

            <template v-if="questsMap[questId].tg_and_max_id_in_form_enabled">
              <v-col cols="6" class="py-0 my-0">
                <v-text-field dense :label="$t('Telegram')" v-model="bookInfo.tg_id" :error-messages="errors.tg_id">
                  <template v-slot:prepend><img src="/static/telegram.svg" height="24" width="22" style="margin: auto;"
                      alt="Иконка" /></template></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0 my-0">
                <v-checkbox class="py-0 my-0 mt-1" v-model="bookInfo.has_max_id" :label="`Есть MAX`"></v-checkbox>
              </v-col>
            </template>

            <v-col v-if="questsMap[questId].request_email" cols="12" class="py-0 my-0">
              <v-text-field dense :label="$t('Email')" v-model="bookInfo.email" :error-messages="errors.email"
                prepend-icon="mdi-email"></v-text-field>
            </v-col>

            <!-- Работа с вводом промокода -->
            <v-col cols="12" class="py-0 my-0" style="cursor: pointer">
              <div class="text-center" v-if="!showEnterCode" @click="showEnterCode = true">
                <v-icon>mdi-ticket-percent-outline</v-icon>{{ $t("Enter promocode/certificate") }}
              </div>
              <template v-else>
                <PromocodeField :link="'/crm/api/user_check_promocode/'" :quest-id="bookInfo.questId"
                  :price="bookInfo.price" :date="bookInfo.date" :time="bookInfo.time"
                  @checkSuccessfull="promocodeCheckSuccessfull" />
              </template>
            </v-col>

            <v-col cols="12" class="py-0 my-0">
              <template v-if="addComment">
                <v-text-field dense :label="$t('Comment')" v-model="bookInfo.comment"></v-text-field>
              </template>
              <template v-else>
                <div class="text-center">
                  <span @click="addComment = !addComment" style="cursor: pointer">{{ $t("Add comment") }}</span>
                </div>
              </template>
            </v-col>
            <v-col cols="12" class="text-left p-0 m-0">{{ questsMap[questId].comment }}
              <div v-for="(agreement, idx) in agreements" :key="idx">
                <input v-model="agreementSelected[idx]" :id="`agreement_${idx}`" type="checkbox" />
                <label class="pl-2" :for="`agreement_${idx}`">{{ agreement.prefix }}
                  <a style="color: black" target="_blank" :href="agreement.url">{{ agreement.name }}</a></label>
              </div>
              <div v-for="(agreement, idx) in questsMap[questId].agreements" :key="`q_${idx}`">
                <input v-model="questAgreementSelected[questId][idx]" :id="`quest_agreement_${idx}`" type="checkbox" />
                <label class="pl-2" :for="`quest_agreement_${idx}`" v-html="agreement.html"></label>
              </div>

            </v-col>
          </v-row>

          <!-- Ошибка бронирования -->
          <v-alert border="bottom" dense class="text-center mt-1" color="pink darken-1" dark v-if="error">{{ error }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="
            () => {
              error = null;
              dialog = false;
            }
          ">{{ $t("Cancel") }}</v-btn>
          <v-btn :disabled="loading || !bookingButtonActive" color="green darken-1" text @click="makeBook">{{ loading ?
            $t("Booking") + "..." : $t("Book") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалогове окно подтверждения -->
    <v-dialog v-if="questId" v-model="showSuccessDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          $t("Completion of Booking")
        }}</v-card-title>

        <v-card-text class="pt-4">
          <h3 class="pb-3">{{ questsMap[questId].success_text }}</h3>
          <h4>
            {{ $t("Date") }}:
            <v-icon>mdi-calendar-month</v-icon>
            {{ bookInfo.date }}
            <v-icon>mdi-clock-outline</v-icon>
            {{ bookInfo.time }}
            <a class="ml-1" target="_blank" rel="nofollow" :href="ical_link">+ {{ $t('Add to calendar') }}</a>
            <br />
            {{ $t("Price") }}: {{ bookPrice }} {{ questsMap[questId].currency }}
            <template v-if="bookInfo.promocodeId">
              <b>{{ $t("Discount") }}: {{ bookInfo.promocodeText }}</b>
            </template>
            <template v-if="bookInfo.discountText">
              <br />
              <b>{{ $t("Discount") }}: {{ bookInfo.discountText }}</b>
            </template>
            <br />
            {{ $t("Address") }}: {{ questsMap[questId].address }}
          </h4>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeSuccessDialog">{{
            $t("Hide")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="moduleType == 'multiple'" class="text-center mb-2" :style="{ color: design.headercolor }">
      <span>
        <v-btn text @click="navPrev(7)" :style="{ color: design.headercolor }"
          :class="today >= date ? 'transparent-button' : ''" :disabled="today >= date">
          <v-icon>mdi-chevron-triple-left</v-icon>
        </v-btn>
        <v-btn text @click="navPrev(1)" :style="{ color: design.headercolor }"
          :class="today >= date ? 'transparent-button' : ''" :disabled="today >= date">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </span>
      {{ curDateString }}
      <v-btn text @click="navNext(1)" :style="{ color: design.headercolor }">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn text @click="navNext(7)" :style="{ color: design.headercolor }">
        <v-icon>mdi-chevron-triple-right</v-icon>
      </v-btn>
    </div>

    <slot>
      <div>
        <Schedule v-for="(quest, idx) in questInfo" :key="idx" :design="design" :quest-id="Number(quest.id)"
          :schedule="quest.schedule" :colors-map="colorsMap" :header-text="quest.quest_name"
          :header-text2="quest.additional_text || ''" :show_weekday="show_weekday" @slotClick="slotClick" />
      </div>
    </slot>

    <div v-if="moduleType == 'single'" class="text-center mt-6">
      <v-btn text @click="navPrev(7)" :style="{ color: design.headercolor }"
        :class="today >= date ? 'transparent-button' : ''" :disabled="today >= date">
        <v-icon>mdi-chevron-left</v-icon>{{ $t("Prev week") }}
      </v-btn>
      <v-btn text @click="navNext(7)" :style="{ color: design.headercolor }">
        {{ $t("Next week") }}
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import Schedule from "./Schedule";
import PromocodeField from "./PromocodeField";
import Vue from "vue";

const DATE_FORMAT = "YYYY-MM-DD";

function startFormResizer(vm) {
  function _checkFormSize() {
    if (vm.$refs && vm.$refs.dialog && vm.$refs.dialog.$refs.content) {
      var dialog = vm.$refs.dialog.$refs.content;

      const top = Number(dialog.style.top.split("px")[0]);
      const dialogHeight = dialog.scrollHeight;
      const totalHeight = top + dialogHeight;
      const windowHeight = window.outerHeight;

      if (totalHeight > windowHeight) {
        dialog.style.height = windowHeight + 20 + "px";
        dialog.style.top = "0px";
      }
    }
  }

  setInterval(_checkFormSize, 500);
}

var moment = require("moment");
//import Vue from "vue";
const axios = require("axios").default;

function sendRoistatLead(name, phone, email, comment, quest_name, date, time) {
  if (phone === null && email === null) {
    return;
  }
  var clientComment = `Комментарий: ${comment}`;
  var gameName = `Бронирование: ${quest_name}`;
  var gameTime = `Время: ${time}`;
  var gameDate = `Дата: ${date}`;

  var comments = [
    gameName,
    gameTime,
    gameDate,
    clientComment
  ];
  var roistat_comment = comments.join('; ');

  let roistast_payload = {
    name: name,
    phone: phone,
    email: email,
    leadName: window.roistat_site,
    text: roistat_comment,
    is_skip_sending: 0
  };
  // eslint-disable-next-line no-console
  console.log("RoiStat goal", roistast_payload)
  window.roistatGoal.reach(roistast_payload);
}

function globalEventMakeBook(name, phone, email, comment, quest_name, date, time) {
  try {
    if (window.yaCounter) {
      window.yaCounter.reachGoal("ORDERED");

      // eslint-disable-next-line no-console
      console.log("goal reached:ORDERED");
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e)
  }
  try {
    if (window.roistat_key) sendRoistatLead(name, phone, email, comment, quest_name, date, time)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e)
  }

}

export default {
  props: {
    link: String,
    bookingLink: String,
    referer: {
      default: "",
      type: String,
    },
    moduleType: {
      default: "single",
      type: String,
    },
    source: String,
    show_weekday: Boolean
  },
  components: {
    Schedule,
    PromocodeField,
  },
  data: () => {
    return {
      quests: [],
      questInfo: [],
      questsMap: {},
      design: {},
      colorsMap: {},
      dialog: false,
      showEnterCode: false,
      bookInfo: {
        name: "",
        phone: "",
        tg_id: "",
        has_max_id: false,
        email: "",
        time: "00:00",
        date: "",
        comment: "",
        modes: {},
        price: 0,
        availableModes: {},
        promoactionText: null,
        promoactionPrice: null,
        promocode: "",
        promocodeText: "",
        promocodeId: 0,
        questId: 0,
        additional_params: {}
      },
      date: moment().format(DATE_FORMAT),
      today: moment().format(DATE_FORMAT),
      dialogHeight: 600,
      clickPointX: 0,
      sendHeightToIframe: "",
      addComment: false,
      loading: false,
      error: "",
      errors: {
        name: [],
        phone: [],
        tg_id: [],
        has_max_id: [],
        email: [],
      },
      mainError: "",
      showSuccessDialog: false,
      loaded: false,
      agreementSelected: {},
      questAgreementSelected: {},
      windowHeight: 1000,
      bookPrice: null,
      discounts: [],
      fulPrice: 0,
      ical_link: null,
      // Используется для отправки в родительскую страницу для ресайза окна
      page_height: null,
      selected_contact: 0,
    };
  },
  created() {
    this.loadData();
    startFormResizer(this);
  },
  mounted() {
    setInterval(this.sendCurrentHeight, 1000);
  },
  computed: {
    questId() {
      if (this.bookInfo.price) {
        return String(this.bookInfo.questId);
      }
      return null;
    },
    //bookPrice() {
    //  if (this.bookInfo.price) {
    //
    //    var base_price = this.bookInfo.discountPrice || this.bookInfo.price;
    //    this.bookInfo.availableModes.forEach((group, idx) => {
    //      base_price =
    //        base_price + group.modes[this.bookInfo.modes[idx]].price_change;
    //    });
    //
    //    // Пересчет в случае наличия промокода
    //    if (this.bookInfo.promocodeId) {
    //      const promocodeValue = this.bookInfo.promocodeValue;
    //      var new_price;
    //      if (this.bookInfo.promocodeChangetype === 1) {
    //        new_price = Number(((100 - promocodeValue) * base_price) / 100);
    //      } else {
    //        new_price = base_price - promocodeValue;
    //      }
    //      base_price = new_price;
    //    }
    //
    //    return base_price;
    //  }
    //  return 0;
    //},
    curDateString() {
      return moment(this.date).locale(window.locale).format("DD MMMM");
    },
    bookingButtonActive() {
      const main_agreements = Object.values(this.agreementSelected).every(Boolean);
      const quest_agreements = Object.values(this.questAgreementSelected[this.questId]).every(Boolean);
      return main_agreements && quest_agreements
    },
  },
  updated() {
    if (this.loaded && this.$refs.dialog && this.$refs.dialog.$refs.content) {
      this.dialogHeight = this.$refs.dialog.clientHeight;
      this.renderDialog();
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      axios
        .get(this.link, {
          params: { date: this.date, source: this.source },
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          let quest_data = response.data.data;

          Vue.set(this, "questInfo", quest_data.quests);

          var questsMap = {};

          quest_data.quests.forEach((element) => {
            questsMap[element.id] = element;
             Vue.set(this.questAgreementSelected, element.id, {});
            element.agreements.forEach((el, idx) => {
              Vue.set(this.questAgreementSelected[element.id], idx, false);
            });
          });
          Vue.set(this, "questsMap", questsMap);

          this.design = quest_data.design;
          this.colorsMap = quest_data.colors_map;
          this.agreements = quest_data.agreements;

          this.agreements.forEach((el, idx) => {
            Vue.set(this.agreementSelected, idx, true);
          });

          this.loading = false;
          this.loaded = true;

          if (quest_data.active === false) {
            this.mainError = this.$t(
              "Бронирование временно невозможно, попробуйте забронировать через оператора"
            );
          }
        })
        .catch(() => {
          this.loaded = false;
          this.loading = false;
          this.mainError = this.$t(
            "Не удалось загрузить расписание. Попробуйте перезагрузить страницу или повторить позднее"
          );
        });
    },
    slotClick(slot, date, event) {
      Vue.set(this.bookInfo, "date", date);
      Vue.set(this.bookInfo, "questId", slot.questId);
      Vue.set(this.bookInfo, "price", slot.price);
      Vue.set(this.bookInfo, "time", slot.time);
      Vue.set(this.bookInfo, "availableModes", slot.modes);
      Vue.set(this.bookInfo, "discountText", slot.discount_text);
      Vue.set(this.bookInfo, "discountPrice", slot.discount_price);
      Vue.set(this.bookInfo, "additional_params", slot.additional_params);
      this.fullPrice = slot.price;
      const questInfo = this.questsMap[slot.questId];
      this.showEnterCode = questInfo.show_promocode_field;

      var modes = {};
      slot.modes.forEach((element, idx) => {
        // eslint-disable-next-line no-console
        //console.log(element, idx);
        modes[idx] = 0;
      });
      Vue.set(this.bookInfo, "modes", modes);
      this.getPriceFromServer();
      this.dialog = true;
      this.clickPointX = event.y;
    },
    checkForm(questId, bookInfo) {
      let error = false;
      // eslint-disable-next-line no-console
      const questInfo = this.questsMap[questId];

      this.errors.email = null;
      this.errors.name = null;
      this.errors.phone = null;
      this.errors.tg_id = null;
      this.errors.has_max_id = null;

      if (
        questInfo.request_email &&
        questInfo.email_required &&
        !bookInfo.email
      ) {
        this.errors.email = this.$t("specify email");
        error = true;
      }

      if (!bookInfo.name || bookInfo.name === "") {
        this.errors.name = this.$t("specify name");
        error = true;
      }

      if (!bookInfo.phone || bookInfo.phone === "") {
        this.errors.phone = this.$t("specify contact phone");
        error = true;
      }

      return error;
    },
    sendBookingRequest(questId, bookInfo) {
      this.loading = true;
      var data = {
        name: bookInfo.name,
        phone: bookInfo.phone,
        tg_id: bookInfo.tg_id,
        has_max_id: bookInfo.has_max_id,
        email: bookInfo.email,
        date: bookInfo.date,
        time: bookInfo.time,
        price: this.bookPrice,
        base_slot_price: bookInfo.price,
        comment: bookInfo.comment,
        modes: bookInfo.modes,
        promocode: bookInfo.promocode,
        additional_params: bookInfo.additional_params,
        source: this.source
      };
      const questInfo = this.questsMap[questId];
      // eslint-disable-next-line no-console

      axios
        .post(this.bookingLink + "?quest_id=" + this.questId, data)
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.dialog = false;
            this.showSuccessDialog = true;
            this.ical_link = response.data.ical_link;
            //this.bookInfo.promocodeId = null;
            this.error = null;
            this.loadData();
            globalEventMakeBook(data.name, data.phone, data.email, data.comment, questInfo.quest_name, data.date, data.time);
          } else {
            this.error = response.data.error;
            if (response.data.field_errors) {
              this.errors.name = response.data.field_errors.name || [];
              this.errors.phone = response.data.field_errors.phone || [];
              this.errors.email = response.data.field_errors.email || [];
            } else {
              this.errors.name = null;
              this.errors.phone = null;
              this.errors.email = null;
            }

          }
        })
        // eslint-disable-next-line
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
          this.loading = false;
          alert(
            this.$t("booking unsuccessfull")
          );
        });
    },
    makeBook() {
      let bookInfo = this.bookInfo;

      const errorsInForm = this.checkForm(this.questId, bookInfo);
      if (!errorsInForm) {
        this.sendBookingRequest(this.questId, bookInfo);
      }
    },
    promocodeCheckSuccessfull(
      promocode,
      change_type,
      value,
      promocode_id,
      promocode_text
    ) {
      this.bookInfo.promocode = promocode;
      this.bookInfo.promocodeText = promocode_text;
      this.bookInfo.promocodeId = promocode_id;
      this.bookInfo.promocodeChangetype = change_type;
      this.bookInfo.promocodeValue = value;
      this.getPriceFromServer();
    },
    getPriceFromServer() {
      const payload = {
        quest_id: this.bookInfo.questId,
        promocode: this.bookInfo.promocode,
        date: this.bookInfo.date,
        time: this.bookInfo.time,
        modes: this.bookInfo.modes,
      };
      axios.post("/crm/api/get_price/", payload).then((response) => {
        this.bookPrice = response.data.data.price;
        Vue.set(this, 'discounts', response.data.data.discounts);
        this.fullPrice = response.data.data.full_price;
      });
    },
    navNext(days) {
      if (this.loading) {
        return;
      }
      this.date = moment(this.date).add(days, "d").format(DATE_FORMAT);
      this.loadData();
    },
    navPrev(days) {
      if (this.loading) {
        return;
      }
      var date = moment(this.date).add(-days, "d");
      var today = moment(this.today);
      date = date < today ? today : date;
      this.date = date.format(DATE_FORMAT);
      this.loadData();
    },
    renderDialog() {
      var clickPointX = this.clickPointX;
      var dialog = this.$refs.dialog.$refs.content;
      var html = document.documentElement;
      var documentHeight = html.clientHeight;
      var dialogHeight = 600;

      var desiredDialogY = Math.max(50, clickPointX - 300);
      var resultBottomSize = desiredDialogY + dialogHeight;
      if (resultBottomSize > documentHeight) {
        desiredDialogY =
          desiredDialogY - resultBottomSize + documentHeight - 50;
      }
      desiredDialogY = Math.max(0, desiredDialogY);
      //var deltaY = desiredDialogY - currentDialogY;
      var deltaY = desiredDialogY;

      dialog.style.top = deltaY + "px";
      dialog.style.height = "auto";

      var dialog_card = dialog.children[0];

      if (window.outerWidth < 500) {
        dialog_card.style.margin = 0;
      }

      // Не понятно нужно ли. пусть будет
      this.windowHeight = window.outerHeight;
      // eslint-disable-next-line no-console
      //console.log([clickPointX, documentHeight, dialogHeight, currentDialogY, desiredDialogY, deltaY])
    },
    sendCurrentHeight() {
      // eslint-disable-next-line no-console
      let height = this.$refs.container.scrollHeight.toString();
      if (height < 670) {
        height = 670
      }
      // eslint-disable-next-line no-console
      if (Number(this.page_height) != Number(height)) {
        Vue.set(this, 'page_height', height)
        window.parent.postMessage(height, '*');
        // eslint-disable-next-line no-console
        console.log("height sent", height, '*');
      }
    },
    closeSuccessDialog() {
      this.showSuccessDialog = false;
      this.bookInfo.promocodeId = null;
      this.bookInfo.promocode = null;
      this.showEnterCode = false;
    },
    modeChanged() {
      this.getPriceFromServer();
    },
    getPhoneMask(quest_id) {
      const t = JSON.parse(
        JSON.stringify(this.questsMap[quest_id].phone_templates)
      );
      return t;
    },
  },
};
</script>

<style>
.transparent-button {
  opacity: 0;
}

.old-price {
  position: relative;
  display: inline-block;
}

.old-price::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%0A%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%22100%25%22%20x2%3D%22100%25%22%20y2%3D%220%22%20stroke%3D%22%23F00%22%20stroke-width%3D%222%22%2F%3E%0A%3C%2Fsvg%3E');
  background-size: cover;
}
</style>